import { useQuery } from '@tanstack/react-query';
import { getTag } from '../../api/tag.ts';

export default function useTag(tagId: string) {
  return useQuery({
    queryKey: ['tags', tagId],
    queryFn: async () => {
      return await getTag(tagId);
    },
    enabled: !!tagId,
  });
}
